import React from "react"

import GroupBy from "../../../../../../gd/manager/group-by/group-by-model"
import DateGrouping_getGroupLabel from "../../../../../system/task/date/functions/get-group-label"
import FieldSelectField from "../../../select-field/select-field"

type Props = {
    className?  : string
    value       : GroupBy
    field       : FieldSelectField
    onClick     : callback
    children?   : any
}

export default function FieldSelectGroupField_InlineValueNotEmpty(props: Props) {

    const groupBy: GroupBy = props.value

    const placeholder = props.field.noValueOption ? props.field.noValueOptionLabel : props.field.placeholder
    const label = !groupBy.field ? placeholder : DateGrouping_getGroupLabel(groupBy)

    const iconClasses = Classes('ui5-ico-15 m-r-8', groupBy.field?.icon)

    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable no-wrap" onClick={props.onClick}>
                {groupBy.field?.icon && <div className={iconClasses}/>}
                {label}
            </div>

            {props.children}
        </React.Fragment>
    )
}